import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, ScrollText } from "lucide-react";
import { API, authHeaders } from "./shared";
import { fmtDateTime } from "@/lib/datetime";

const ACTION_STYLES = {
  create: "bg-green-500/15 text-green-400",
  edit: "bg-blue-500/15 text-blue-300",
  void: "bg-red-500/20 text-red-400",
  status: "bg-yellow-500/15 text-yellow-400",
};

export default function AuditLogModule({ token, onAuthError }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/finance/audit`, authHeaders(token)).then((r) => setItems(r.data || []))
      .catch((e) => { if (e.response?.status === 401) onAuthError?.(); })
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#F2B705]" /></div>;

  return (
    <div className="space-y-4" data-testid="audit-log-module">
      <div>
        <h3 className="text-white font-bold flex items-center gap-2"><ScrollText size={16} /> Financial Audit Trail</h3>
        <p className="text-white/45 text-sm">Permanent record of every financial action. Nothing here can be deleted.</p>
      </div>
      <div className="bg-[#0C0C0C] border border-white/10 rounded-xl overflow-hidden">
        {items.length === 0 && <p className="text-white/35 text-sm p-5">No financial activity recorded yet.</p>}
        <div className="divide-y divide-white/5 max-h-[620px] overflow-y-auto">
          {items.map((a) => (
            <div key={a.id} className="px-4 py-2.5" data-testid={`audit-row-${a.id}`}>
              <div className="flex flex-wrap items-center gap-2 text-sm">
                <span className={`text-[10px] px-2 py-0.5 rounded font-bold uppercase ${ACTION_STYLES[a.action] || "bg-white/10 text-white/60"}`}>{a.action}</span>
                <span className="text-white/80">{a.summary}</span>
                <span className="ml-auto text-white/35 text-xs">{fmtDateTime(a.at)}</span>
              </div>
              <div className="text-white/40 text-xs mt-0.5">by {a.user} · {a.entity.replace("_", " ")}</div>
              {(a.changes || []).length > 0 && (
                <div className="mt-1 text-xs text-white/45 space-y-0.5">
                  {a.changes.map((c, i) => (
                    <div key={i}>• <span className="text-white/60">{c.field}</span>: <span className="text-red-400/70 line-through">{String(c.from ?? "—")}</span> → <span className="text-green-400/80">{String(c.to ?? "—")}</span></div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
